type DebounceOptions = {
  leading?: boolean;
  trailing?: boolean;
};

export default function debounce<T extends (...args: any[]) => any>(fn: T, wait = 300, options: DebounceOptions = {}) {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  const leading = options.leading === true;
  const trailing = options.trailing !== false;

  function debounced(this: any, ...args: Parameters<T>) {
    const callLeading = leading && !timeout;

    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      timeout = null;

      if (trailing && !callLeading) fn.apply(this, args);
    }, wait);

    if (callLeading) fn.apply(this, args);
  }

  // Optional helpers
  (debounced as any).cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  (debounced as any).flush = function (this: any, ...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
      fn.apply(this, args);
    }
  };

  return debounced as T & {
    cancel: () => void;
    flush: (...a: Parameters<T>) => void;
  };
}
